import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {BehaviorSubject, Observable} from "rxjs";
import Pagination from "../../model/pagination";
import CurrencyModel from "../../model/currency.model";
import {environment} from "../../environments/environment";
import QueryEncoder from "../queryEncoder";

@Injectable()
export default class CurrencyService {
    private currenciesSubject = new BehaviorSubject<CurrencyModel[]>([]);
    public currencies$ = this.currenciesSubject.asObservable();

    public constructor(private http: HttpClient) {
        this.list().subscribe(result => {
            this.currenciesSubject.next(result.results);
        });
    }

    public list(query?: string, page?: number, limit?: number, sort?: string, direction?: string): Observable<Pagination<CurrencyModel>> {
        query = query || '';
        page = page || 1;
        limit = limit || 15;
        sort = sort || '';

        let sorting = {};
        sorting[sort] = direction;

        let q = {query, page, limit, sorting};

        return this.http
            .get<Pagination<CurrencyModel>>(environment.apiUrl + '/currencies?' + QueryEncoder.encodeURI(q));
    }

    public show(id: number): Observable<CurrencyModel> {
        return this.http.get<CurrencyModel>(environment.apiUrl + '/currencies/' + id);
    }
}
